import ProductCell from 'Presentation/Components/RequestCard/Components/ProductCell'

const TitleCell: React.FC<any> = props => {
	const {
		isFixed,
		title,
		documentStatus,
		dimension,
		options,
		accessories,
		thickness,
		outerMaterial,
		innerMaterial,
		printingOption,
		forming,
		sustainabilities,
		certificates,
		remark,
	} = props.row.original
	const index = props.row.index
	const value = props.value
	const { onChangeItemTitle, onChangeItemRemark, canInput } = props.cell.column

	if (isFixed) {
		return (
			<ProductCell
				{...value}
				dimension={dimension}
				options={options}
				accessories={accessories}
				thickness={thickness}
				outerMaterial={outerMaterial}
				innerMaterial={innerMaterial}
				printingOption={printingOption}
				forming={forming}
				sustainabilities={sustainabilities}
				certificates={certificates}
				disabledNote={canInput}
				note={remark ?? ''}
				onChangeNote={val => onChangeItemRemark(val, index)}
			/>
		)
	} else if (documentStatus === '10' && !isFixed) {
		return (
			<textarea
				placeholder="กรุณากรอกชื่อสินค้า"
				rows={5}
				className="form-control form-control-sm w-100"
				value={title}
				onChange={e => onChangeItemTitle(e.target.value, index)}
			/>
		)
	} else if (documentStatus !== '10' && !isFixed) {
		return <div dangerouslySetInnerHTML={{ __html: title ?? '-' }}></div>
	} else {
		return <></>
	}
}

export default TitleCell
